import { Component, OnInit, ViewChild, TemplateRef, Output, EventEmitter } from '@angular/core';
import { ImportStep0Component } from './import-step0/import-step0.component';
import { ImportStep10Component } from './import-step10/import-step10.component';
import { ImportStep20Component } from './import-step20/import-step20.component';
import { ImportStep30Component } from './import-step30/import-step30.component';
import { WizardComponent } from '../../shared/components/wizard/wizard.component';
import { SyncDataService } from '../services/sync-data.service';
import { ImportStep40Component } from './import-step40/import-step40.component';
import { IFacadeExportObject } from 'app/core/typings/IFacadeExportObject';

@Component({
  selector: 'biz-sync-data-import',
  templateUrl: './sync-data-import.component.html',
  styleUrls: ['./sync-data-import.component.scss']
})

export class SyncDataImportComponent implements OnInit {
  @ViewChild(TemplateRef, { static: false }) template: TemplateRef<any>;
  @Output() onFinish = new EventEmitter();

  public steps: Array<any>;
  public syncData: IFacadeExportObject;
  public initialStep = 0;
  public messageBody: string;
  public importingStatus: string;
  public onNextFlag = false;
  public onBackFlag = false;

  constructor(private _syncDataService: SyncDataService) {
    this.syncData = {
      EnabledMail: false,
      FilePath: '',
      FileToImport: null,
      Reports: null,
      OverrideTargetResources: true,
      EntityTables: null,
      UserTables: null,
      StringConnection: '',
      ProviderType: '',
      AreNewUsers: true,
      ModifiedDescriptor: '',
      OriginalDescriptor: '',
      UsersAvailable: true,
      UsersSelected: true,
    };
    this.getImportingStatus();
  }

  ngOnInit() {
    this.steps = [ImportStep0Component, ImportStep10Component, ImportStep20Component, ImportStep30Component, ImportStep40Component];
  }

  public onNext() {
    this.onNextFlag = true;
  }

  public onNextValidation(event) {
    this.onNextFlag = false;
    if (event)
      this.initialStep += 1;
  }

  public onPrevious() {
    this.onBackFlag = true;
    this.initialStep -= 1;
    this.onBackFlag = false;
  }

  public onImport() {
    this.onNextFlag = true;
  }

  public closeModal() {
    this.onFinish.emit();
  }

  public setData(data) {
    this.syncData = _.extend(this.syncData, data);
  }

  private getImportingStatus() {
    this._syncDataService.getImportStatusFile().then((status: string) => {
      this.importingStatus = status;
      if (this.importingStatus === 'InProgress') {
        this.initialStep = 4;
      }
    });
  }

}
